export const environment = {
  production: true,
  firebaseConfig : {
    apiKey: "AIzaSyCF7Ad3dargjtBneovIQK2rNO3TeTbIX9g",
    authDomain: "illusbook.com",
    databaseURL: "https://illusbookdata-default-rtdb.firebaseio.com",
    projectId: "illusbookdata",
    storageBucket: "illusbookdata.appspot.com",
    messagingSenderId: "247705827203",
    appId: "1:247705827203:web:60ba65faa87de54775e8b6",
    measurementId: "G-51JJ9QPH41"
  }
};
